module.exports = __webpack_public_path__ + "img/close_gray.edd19aeb.svg";